/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_TimeInputs */

const en_lesson_field_time = /** @type {(inputs: Lesson_Field_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const he_lesson_field_time = /** @type {(inputs: Lesson_Field_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעה`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Lesson_Field_TimeInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_time = /** @type {((inputs?: Lesson_Field_TimeInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_TimeInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_time(inputs)
	return he_lesson_field_time(inputs)
});